<template>
  <placeholder-screen title="Strengths & Opportunities">
    <p class="text-left">
      To grow, you need to know your strengths and your opportunities for improvement. </p>
    <p class="text-left">
      We’ll provide you with an
      easy-to-answer series of questions to uncover your current strengths along with the areas on which you
      should focus. </p>
    <p class="text-left">
      This is like sitting down with a personal coach to take your career to the next level -
      but without paying hundreds of dollars for the hour!
    </p>
    <p>
      This feature will be available as part of the <em>Grow</em> release in January.
    </p>
  </placeholder-screen>
</template>

<script>
  import { mapActions } from 'vuex';
  import PlaceholderScreen from '../UIComponents/PlaceholderScreen.vue';
 
  export default {
    created() {
      this.setNavbarTitle('Strengths & Opportunities');
    },
    methods: {
      ...mapActions('UI', ['setNavbarTitle']),
    },
    components: {
      PlaceholderScreen
    }
  }

</script>
